
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/dienstleistungen/ot-awareness-training",
      function () {
        return require("private-next-pages/[locale]/dienstleistungen/ot-awareness-training.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/dienstleistungen/ot-awareness-training"])
      });
    }
  